export default "__VITE_ASSET__Dp7Fh6ML__"